
import PropTypes from 'prop-types';
import { Box, Collapse, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import { KeyboardArrowUp as KeyboardArrowUpIcon, KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material'
import React, { useState, useEffect } from 'react';
export default function WorklogListnew(props) {
  const { row, index } = props;
  const [selectedIndex, setSelectedIndex] = useState("");
  const maxLength = 50;

  const handleClick = index => {
    if (selectedIndex === index) {
      setSelectedIndex("")
    } else {
      setSelectedIndex(index)
    }
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleClick(index)}
          >
            {index === selectedIndex ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.catData.grievanceCategory}
        </TableCell>

        <TableCell align="left">{row.subCat}</TableCell>

      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
          <Collapse in={index === selectedIndex} timeout="auto" unmountOnExit>
            {row.faqSubCatPojo.map((item, idxx) => {
             // console.log(item, 'in theeeee rowwwwwww');
              return (
                <Box sx={{ margin: 1 }}>
                  <Typography variant="subtitle2" component="div">
                    FAQ:&nbsp;
                    <Typography variant="body2" component="label">
                      {item?.questionStr}
                    </Typography>
                  </Typography>
                  <Typography variant="subtitle2" component="div">
                    FAQA:&nbsp;
                    <Typography variant="body2" component="label">
                      {item?.answerStr}
                    </Typography>
                  </Typography>
                </Box>
              )
            })
            }
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

// WorklogListnew.propTypes = {
//   row: PropTypes.shape({
//     // id: PropTypes.number.isRequired,
//     // worklogComment: PropTypes.string.isRequired,
//     crtdOn: PropTypes.any.isRequired,
//     updtdBy: PropTypes.any.isRequired,
//   }).isRequired,
// };